(function(){
  var toast = document.getElementById('xmas-toast');
  if (!toast) return;

  var closeBtn = toast.querySelector('.xmas-toast__close');
  var hideTimer;

  function showToast(){
    clearTimeout(hideTimer);
    toast.classList.add('xmas-toast--show');
    toast.setAttribute('aria-hidden','false');
    hideTimer = setTimeout(hideToast, 5500);
  }
  function hideToast(){
    toast.classList.remove('xmas-toast--show');
    toast.setAttribute('aria-hidden','true');
  }
  if (closeBtn) closeBtn.addEventListener('click', hideToast);

  // Patch fetch (AJAX add-to-cart)
  var _fetch = window.fetch;
  window.fetch = function(input, init){
    var url = typeof input === 'string' ? input : (input && input.url);
    var isAdd = url && url.indexOf('/cart/add') > -1;
    return _fetch(input, init).then(function(res){
      if (isAdd && res && res.ok) { try{ showToast(); }catch(e){} }
      return res;
    });
  };

  // Patch XHR (fallback)
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url){
    this._isAddToCart = typeof url === 'string' && url.indexOf('/cart/add') > -1;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function(){
    if (this._isAddToCart) {
      this.addEventListener('load', function(){
        if (this.status >= 200 && this.status < 300) { try{ showToast(); }catch(e){} }
      });
    }
    return _send.apply(this, arguments);
  };
})();
